"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSSSEnvironment = void 0;
const isSSSEnvironment = () => window.IS_SSS_ENABLED === 'true';
exports.isSSSEnvironment = isSSSEnvironment;
//# sourceMappingURL=url.utils.js.map